import forEach from 'lodash/forEach';
import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useSearchParams } from 'react-router-dom';
import Markdown from 'markdown-to-jsx';
import QueryString from 'qs';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import Head from 'components/Head';
import MaxWidthContainer from 'components/MaxWidthContainer';
import Menubar from 'components/Menubar';
import MobileTabBar from 'components/MobileTabBar';
import CommentPopup from 'components/CommentPopup';
import Footer from 'components/Footer';

import { httpCall } from 'functions/httpAction';
import { fetchAppLaunch } from 'functions/appLaunch';
import { firebaseAuth } from 'utils/firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';

import { usePathname } from 'next/navigation';
import redirectToLogin from 'utils/redirectToLogin';

export default function ProductDetailReviews() {
  const router = useRouter();
  const { asPath } = router;
  const { itemID } = router.query;
  const [filterState, setFilterState] = useState(-10);

  //from AppLaunch API
  const [arrNotificationState, setArrNotificationState] = useState(null);
  const [arrStoresState, setArrStoresState] = useState(null);
  const [arrProductOriginsState, setArrProductOriginsState] = useState(null);
  const [arrCategoryState, setArrCategoryState] = useState([]);
  const [arrSearchSkinProblemState, setArrSearchSkinProblemState] = useState(
    []
  );
  const [arrFactorTypesState, setArrFactorTypesState] = useState([]);
  const [arrBannerState, setArrBannerState] = useState([]);
  const [arrReviewSourcesState, setArrReviewSourcesState] = useState([]);
  const [arrIngridentSafetyState, setArrIngridentSafetyState] = useState([]);
  // const [arrIngridentsFeatureState, setArrIngridentsFeatureState] = useState([]);

  //from Product API
  const [productNameState, setProductNameState] = useState('');
  const [productBrandState, setProductBrandState] = useState({});
  const [productImageState, setProductImageState] = useState([]);
  const [productRatingState, setProductRatingState] = useState(null);
  const [productReviewCountState, setProductReviewCountState] = useState(0);
  const [
    arrProductReviewFactorOverviewState,
    setArrProductReviewFactorOverviewState,
  ] = useState([]);
  const [arrProductReviewsState, setArrProductReviewsState] = useState([]);

  const [isUserLoggedIn, setIsUserLoggeedIn] = useState(false);

  const [firUser, setFirUser] = useState(null);

  const [arrKolState, setArrKolState] = useState([]);
  const [blockKolState, setBlockKolState] = useState('');

  const [isCommentModalShow, setIsCommentModalShow] = useState(false);

  const pathname = usePathname();

  function appLaunch() {
    fetchAppLaunch().then(async ([success, error, data]) => {
      if (data.notifications) {
        setArrNotificationState(data.notifications);
      }

      if (data.stores) {
        setArrStoresState(data.stores);
      }

      if (data.product_origins) {
        setArrProductOriginsState(data.product_origins);
      }

      if (data.category_tree) {
        setArrCategoryState(data.category_tree);
      }

      if (data.search_skin_problem_keywords) {
        setArrSearchSkinProblemState(data.search_skin_problem_keywords);
      }

      if (data.factor_types) {
        setArrFactorTypesState(data.factor_types);
      }

      if (data.review_sources) {
        setArrReviewSourcesState(data.review_sources);
      }

      if (data.ingredient_safeties) {
        setArrIngridentSafetyState(data.ingredient_safeties);
      }

      // if (data.ingredient_features) {
      //   setArrIngridentsFeatureState(data.ingredient_features);
      // }

      fetchKolContent();
    });
  }

  async function checkSignIn() {
    onAuthStateChanged(firebaseAuth, (user) => {
      if (user) {
        setIsUserLoggeedIn(true);
        setFirUser(user);
      } else {
        setIsUserLoggeedIn(false);
        setFirUser(null);
      }
    });
  }

  async function fetchKolContent() {
    const token = firUser ? firUser.accessToken : null;
    try {
      const [success, error, statusCode, data] = await httpCall(
        'get',
        process.env.NEXT_PUBLIC_API_HOST +
          '/api/v2/product/' +
          router.query.itemID +
          '/kols',
        token,
        null
      );

      if (success == true) {
        if (data.name) {
          setProductNameState(data.name);
        }

        if (data.brand) {
          setProductBrandState(data.brand);
        }

        if (data.images) {
          setProductImageState(data.images);
        }

        if (data.rating != null) {
          setProductRatingState(data.rating);
        }

        if (data.review_count != null) {
          setProductReviewCountState(data.review_count);
        }

        if (data.kols) {
          setArrKolState(data.kols);
        }

        if (data.review_factor_overview != null) {
          var arrProductReviewFactorOverviewTmp = [];

          data.review_factor_overview.forEach((element) => {
            arrProductReviewFactorOverviewTmp.push(element);
          });

          setArrProductReviewFactorOverviewState(
            arrProductReviewFactorOverviewTmp
          );
        }

        if (data.reviews != null) {
          var arrProductReviewsTmp = [];

          data.reviews.forEach((element) => {
            arrProductReviewsTmp.push(element);
          });

          setArrProductReviewsState(arrProductReviewsTmp);
        }

        // calculateRating()
        // loadBlockCommentsState();
      } else {
        console.log('api error', errorCall);
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  function loadBlockKol() {
    var blockKolTemp = [];
    const targetItemCount = isUserLoggedIn ? arrKolState.length : 3;

    for (let index = 0; index < arrKolState.length; index += 1) {
      const element = arrKolState[index];
      const metaData = element?.meta;
      const metaSite = metaData?.site_name;
      const targetIcon =
        metaSite === 'YouTube'
          ? '/svgs/youtube.svg'
          : metaSite === 'Instagram'
            ? '/svgs/instagram.svg'
            : '/svgs/chat-small.svg';

      blockKolTemp.push(
        <div>
          <div
            className="hidden cursor-pointer lg:block lg:h-[241px] lg:w-[304px]"
            onClick={() => {
              if (isUserLoggedIn) {
                window.open(element?.url, '_blank');
              } else {
                redirectToLogin(asPath);
              }
            }}
          >
            {metaData?.image?.url ? (
              <div className="relative h-[170px] w-full rounded-xl object-cover">
                <img
                  className="h-full w-full rounded-xl object-cover"
                  src={
                    metaData?.image?.url == ''
                      ? '/images/chat_empty.png'
                      : metaData?.image?.url
                  }
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = '/images/chat_empty.png';
                  }}
                />
                {isUserLoggedIn == false ? (
                  <div className="absolute bottom-0 left-0 right-0 top-0 flex items-center justify-center rounded-lg bg-black/30 text-white">
                    <img
                      className={`h-[61px] w-[61px] ${!isUserLoggedIn ? 'noselect' : ''}`}
                      src="/svgs/lock-open-white.svg"
                    ></img>
                  </div>
                ) : null}
              </div>
            ) : (
              <div className="hidden w-full items-center justify-center rounded-xl object-cover lg:flex">
                <img src="/images/chat_empty.png" />
              </div>
            )}
            <div className="mt-[16px] flex w-full items-center gap-x-4 truncate">
              <div className="w-full">
                <div className="flex items-center text-[16px] font-[400]">
                  {
                    <img
                      src={targetIcon}
                      className={`mr-[4px] h-[20px] w-[20px] ${!isUserLoggedIn ? 'noselect' : ''}`}
                      alt=""
                    />
                  }
                  <span
                    className={`truncate ${!isUserLoggedIn ? 'noselect' : ''}`}
                  >
                    {metaData?.title ?? '其他評論'}
                  </span>
                </div>
                <div className="text-[16px] font-[400] text-[#4A4A4A]">
                  {!isUserLoggedIn && index > 1 ? (
                    <Skeleton height={24} />
                  ) : (
                    <div
                      className={`truncate text-[16px] font-[400] text-[#4A4A4A] ${!isUserLoggedIn ? 'noselect' : ''}`}
                    >
                      {metaData?.description ??
                        '427 likes, 1 comments - sorra.beauty on...'}
                    </div>
                  )}
                </div>
              </div>
              {/* <img className="grow-0 w-[24px] h-[24px]" src="/svgs/chevron-right.svg" alt="" /> */}
            </div>
          </div>

          <div
            className="block lg:hidden"
            onClick={() => {
              if (isUserLoggedIn) {
                window.open(element?.url, '_blank');
              } else {
                redirectToLogin(asPath);
              }
            }}
          >
            <div className="w-full">
              {metaData?.image?.url ? (
                <div className="relative h-[170px] w-full rounded-xl object-cover">
                  <img
                    className="h-full w-full rounded-xl object-cover"
                    src={
                      metaData?.image?.url == ''
                        ? '/images/chat_empty.png'
                        : metaData?.image?.url
                    }
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = '/images/chat_empty.png';
                    }}
                  />
                  {isUserLoggedIn == false ? (
                    <div className="absolute bottom-0 left-0 right-0 top-0 flex items-center justify-center rounded-lg bg-black/30 text-white">
                      <img
                        className={`h-[61px] w-[61px] ${!isUserLoggedIn ? 'noselect' : ''}`}
                        src="/svgs/lock-open-white.svg"
                      ></img>
                    </div>
                  ) : null}
                </div>
              ) : (
                <div className="hidden w-full items-center justify-center rounded-xl object-cover lg:flex">
                  <img src="/images/chat_empty.png" />
                </div>
              )}
              <div className="mt-[16px] flex w-full items-center space-x-4">
                <div className="w-[calc(100%-40px)]">
                  <div className="flex w-full items-center text-[18px] font-[500]">
                    <div className="truncate">
                      {targetIcon !== '' ? (
                        <img
                          src={targetIcon}
                          className={`mr-[4px] h-[20px] w-[20px] ${!isUserLoggedIn ? 'noselect' : ''}`}
                          alt=""
                        />
                      ) : null}
                    </div>
                    <div
                      className={`w-[calc(100%-24px)] truncate ${!isUserLoggedIn ? 'noselect' : ''}`}
                    >
                      {metaData?.title ?? '其他評論'}
                    </div>
                  </div>
                  <div className="mt-[8px]">
                    {!isUserLoggedIn && index > 1 ? (
                      <Skeleton height={24} />
                    ) : (
                      <div
                        className={`truncate text-[16px] font-[400] text-[#4A4A4A] ${!isUserLoggedIn ? 'noselect' : ''}`}
                      >
                        {metaData?.description ??
                          '427 likes, 1 comments - sorra.beauty on...'}
                      </div>
                    )}
                  </div>
                </div>
                <img
                  className="h-[24px] w-[24px]"
                  src="/svgs/chevron-right.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      );

      if (index === 1 && !isUserLoggedIn) {
        blockKolTemp.push(
          <div>
            <div className="hidden h-[241px] lg:block">
              <div
                className="flex h-[170px] w-full items-center justify-center rounded-xl"
                style={{
                  backgroundImage: `linear-gradient(to right, #FFF4E7, #FFEAEA`,
                }}
              >
                <img
                  src="/svgs/unlock-influencer.svg"
                  width={87}
                  height={80}
                  alt=""
                />
              </div>
              <div className="mt-[16px] truncate">
                <div className="flex items-center text-[14px] font-[500]">
                  <img
                    src="/svgs/lock-open.svg"
                    width={16}
                    height={16}
                    alt=""
                    className="mr-[4px]"
                  />
                  成為會員來解鎖全部 KOL 評論
                </div>
              </div>
            </div>
            <div className="block lg:hidden">
              <div
                className="w-full rounded-lg px-[16px] py-[16px] lg:px-[24px]"
                style={{
                  backgroundImage: `linear-gradient(to right, #FFF4E7, #FFEAEA`,
                }}
              >
                <div className="flex">
                  <div className="flex grow items-center text-base font-bold text-[#111928]">
                    <img className="mr-[4px]" src="/svgs/lock-open.svg"></img>
                    成為會員來解鎖全部 KOL 評論
                  </div>
                  <button
                    className="flex h-[41px] flex-row items-center justify-center rounded-[8px] bg-sorra-pink px-[20px] py-[10px] text-[#fff]"
                    onClick={() => {
                      redirectToLogin(asPath);
                    }}
                  >
                    成為會員
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      }
    }

    setBlockKolState(blockKolTemp);
  }

  useEffect(() => {
    checkSignIn();
  }, []);

  useEffect(() => {
    if (router.query.itemID) {
      appLaunch();
    }
  }, [router.query]);

  useEffect(() => {
    fetchKolContent();
  }, []);

  useEffect(() => {
    loadBlockKol();
  }, [arrKolState, isUserLoggedIn]);

  return (
    <div>
      <Head />

      <main>
        <Menubar
          props={{
            homeExtend: false,
            notifications: arrNotificationState,
            sourceUI: 'ProductDetailReviews',
          }}
        />

        <div
          className={
            'globals-centerContentsMargin' +
            (arrNotificationState?.length > 0 ? ' withNoti' : '')
          }
          style={{ marginBottom: 0 + 'px' }}
        >
          <div className="">
            <MaxWidthContainer className="flex p-4">
              <img src="/svgs/chevron-left.svg"></img>
              <a
                href={'/product/' + itemID}
                className="pl-[8px] font-medium text-sorra-gray-900"
              >
                返回
              </a>
            </MaxWidthContainer>
          </div>
        </div>

        <div className="mb-[24px] mt-[12px] lg:mb-[40px] lg:mt-[40px]">
          <MaxWidthContainer className="flex items-center px-4">
            <div className="w-[80px] lg:w-[112px]">
              <div className="h-[80px] w-[80px] rounded-lg bg-[#F5F5F5] lg:h-[112px] lg:w-[112px] lg:p-[12px] lg:p-[4px]">
                <img src={productImageState[0]?.url}></img>
              </div>
            </div>
            <div className="grow pl-[16px] lg:pl-[24px]">
              <div className="text-sm font-normal text-sorra-gray-800 lg:text-base">
                {productBrandState?.name}
              </div>
              <div className="pt-[4px] text-lg font-medium text-sorra-gray-900 lg:text-2xl">
                {productNameState}
              </div>
            </div>
          </MaxWidthContainer>
        </div>

        <div className="h-[1px] w-full bg-[#E7E7E7]"></div>

        <div className="my-[26px] lg:my-[40px]">
          <MaxWidthContainer className="px-4">
            <div className="flex">
              <div className="text-2xl font-bold text-sorra-gray-900">
                其他評論
              </div>

              {/* <button className="flex lg:hidden h-[34px] ml-auto mr-0 items-center justify-center rounded-lg bg-sorra-pink px-[12px] text-white menubar-normal-search-button" style={{ marginLeft: 'auto', marginRight: 0 + 'px' }}>
                <img className='w-[16px] h-[16px]' src='/svgs/chat.svg'></img>
                <p className="text-sm text-white">留評價</p>
              </button> */}
            </div>
            <div className="mt-[24px] flex flex-row">
              <div className="grid grid-cols-1 gap-4 lg:grid-cols-4">
                {blockKolState}
              </div>
            </div>
          </MaxWidthContainer>
        </div>
      </main>

      <CommentPopup
        externalPopupShown={isCommentModalShow}
        externalProductID={null}
        externalProductBrandName={null}
        externalProductName={null}
        setExternalPopupShown={setIsCommentModalShow}
      />

      <Footer />

      <MobileTabBar props={{ highlighted: 'home' }} />
    </div>
  );
}
